module.exports = __webpack_public_path__ + "static/media/vectorUserDetail.0edf5e58.svg";